/**
 * Band Service - Handles band-related operations
 */

import { fetchWithAuth, API_URL } from './ApiService';

class BandService {
  /**
   * Get all bands where the current user is a member
   * @returns {Promise<Array>} Array of user's bands
   */
  async getUserBands() {
    try {
      const response = await fetchWithAuth(`${API_URL}/bands`);
      return response.data || [];
    } catch (error) {
      console.error('Error fetching user bands:', error);
      return [];
    }
  }

  /**
   * Update setlist band assignment
   * @param {string} setlistId - The setlist ID
   * @param {string|null} bandId - The band ID to assign, or null to unassign
   * @returns {Promise<Object>} Updated setlist
   */
  async assignSetlistToBand(setlistId, bandId) {
    try {
      const response = await fetchWithAuth(`${API_URL}/setlists/${setlistId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          band_id: bandId
        })
      });

      if (!response.success) {
        throw new Error(response.error || 'Failed to assign setlist to band');
      }

      return response.setlist;
    } catch (error) {
      console.error('Error assigning setlist to band:', error);
      throw error;
    }
  }
}

// Export singleton instance
const bandService = new BandService();
export default bandService;